import type { RiveFile } from '@rive-app/react-canvas';
import { makeAutoObservable } from 'mobx';

export class RiveFileStore {
  public allFilesToPreload: string[] = [];
  public riveFileMap = new Map<string, RiveFile>();
  private refCounts = new Map<string, number>();

  constructor() {
    makeAutoObservable(this);
  }

  addFileToPreload(url: string) {
    if (!this.allFilesToPreload.includes(url)) {
      this.allFilesToPreload.push(url);
    }
  }

  removeFromPreload(url: string) {
    const index = this.allFilesToPreload.indexOf(url);
    if (index !== -1) {
      this.allFilesToPreload.splice(index, 1);
    }
  }

  setFile(url: string, file: RiveFile) {
    this.riveFileMap.set(url, file);
  }

  removeFile(url: string) {
    const file = this.riveFileMap.get(url);
    if (file) {
      try {
        file.cleanup();
      } catch {
        // RiveFile.cleanup() may throw if already destroyed; ignore.
      }
      this.riveFileMap.delete(url);
    }
  }

  getFile(url?: string) {
    if (!url) return;
    return this.riveFileMap.get(url);
  }

  acquire(url: string) {
    this.refCounts.set(url, (this.refCounts.get(url) ?? 0) + 1);
    return this.riveFileMap.get(url);
  }

  release(url: string) {
    const next = (this.refCounts.get(url) ?? 1) - 1;
    if (next <= 0) {
      this.refCounts.delete(url);
      this.removeFile(url);
    } else {
      this.refCounts.set(url, next);
    }
  }
}
